





























import { defineComponent, computed } from '@vue/composition-api';
// @ts-ignore
import ArrowDown from '@/assets/icons/arrow_down.svg';

export default defineComponent({
  components: {
    ArrowDown
  },
  name: 'NavigationItem',
  props: {
    id: {
      type: Number,
      required: true
    },
    selected: {
      type: Boolean,
      default: false
    },
    childSelected: {
      type: Boolean,
      default: false
    },
    hasChildren: {
      type: Boolean,
      required: true
    },
    text: {
      type: String,
      default: '',
    },
    level: {
      type: Number,
      required: true
    },
    isOpen: {
      type: Boolean,
      required: true
    },
    mobileNav: {
      type: Boolean,
      default: false
    }
    
  },
  emits: {
    'nav-click': (/*id: number*/) => true,
    'select-click': (/*id: number*/) => true
  },
  setup(props) {

    const clickable = computed(() => {
      if(props.hasChildren) return true;
      if(props.selected) return false;
      return true;
    });

    return {
      clickable
    };
  }
});
